import { LinkTokenResponse } from '@leaflink/stash';

import { URLS } from '@/constants';
import JSONTransform from '@/utils/json-transform';

import { apiSlugSession } from '../session';
/**
 * Create a Plaid link token
 */
export interface PostLinkTokenData {
  account_id?: string;
}

export const postLinkToken = async (data: PostLinkTokenData = {}): Promise<LinkTokenResponse> => {
  const url = `${URLS.SETTINGS.BILLING.BASE}/${URLS.SETTINGS.BILLING.PLAID_LINK_TOKEN}/`;
  const params = { error_format: 'jsonapi' };
  const response = await apiSlugSession.post(url, data, { params });

  return new JSONTransform(response.data).toSnakeCaseKeys();
};

/**
 * Verify Plaid account
 */
export const postVerifyAccount = async (data = {}) => {
  const url = `${URLS.SETTINGS.BILLING.BASE}/${URLS.SETTINGS.BILLING.PLAID_VERIFY}/`;
  const params = { error_format: 'jsonapi' };
  const response = await apiSlugSession.post(url, data, { params });

  return response.data;
};
